import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { DEFAULT_LANGUAGE } from '../i18n/config';

export const useLocaleStore = create()(
  persist(
    (set) => ({
      locale: DEFAULT_LANGUAGE,
      setLocale: (locale) => set({ locale }),
    }),
    {
      name: 'educa360-locale',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
